import React from "react";
import { StyledImage } from "./StyledImage";
import { View } from "react-native";
import CloseImageIcon from "../../assets/icons/closeImage.svg";
import Rotate90Icon from "../../assets/icons/rotate90.svg";
import { IconButton } from "../buttons/IconButton";
import { isWeb } from "../../environment";
import colors from "../../styles/colors";
interface FormImageProps {
  uri: string;
  onCloseButtonPress: () => void;
  onRotateButtonPress?: () => void;
}

const margin = 5;

export const FormImage: React.FC<FormImageProps> = ({
  uri,
  onCloseButtonPress,
  onRotateButtonPress,
}) => {
  return (
    <View style={isWeb() ? { width: 230, margin } : undefined}>
      <StyledImage
        imageProps={{ source: { uri } }}
        borderRadius={5}
        showLoader
        style={
          isWeb()
            ? { margin }
            : {
                flex: 1,
                margin,
              }
        }
        height={isWeb() ? 160 : 120}
        width={isWeb() ? 230 : undefined}
      />
      <View
        style={{
          position: "absolute",
          top: 14,
          right: 6,
        }}
      >
        <IconButton onPress={onCloseButtonPress}>
          <CloseImageIcon />
        </IconButton>
      </View>
      {!!onRotateButtonPress && (
        <View
          style={{
            position: "absolute",
            bottom: 10,
            right: 2,
            backgroundColor: colors.white,
            borderRadius: 50,
            shadowRadius: 5,
            shadowColor: colors.black,
            shadowOpacity: 0.2,
          }}
        >
          <IconButton
            onPress={onRotateButtonPress}
            style={{ padding: 3 }}
            size={25}
          >
            <Rotate90Icon />
          </IconButton>
        </View>
      )}
    </View>
  );
};
